import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {Icons} from '../icon/icon.component';
import {ButtonType} from './ButtonType';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent {

    public isActionInProgress: boolean = false;

    @Input()
    public icon: Icons | undefined;

    @Input()
    public type: ButtonType = 'primary';

    @Input()
    public disabled: boolean = false;

    @Input()
    public wrapText: boolean = false;

    @Input()
    public action: (() => Promise<void>) | undefined;

    constructor(private changeDetectorRef: ChangeDetectorRef) {
    }

    public async execute(): Promise<void> {
        if (!this.disabled && this.action !== undefined) {
            this.isActionInProgress = true;
            await this.action();
            this.isActionInProgress = false;
            this.changeDetectorRef.markForCheck();
        }
    }
}
